module.exports = __webpack_public_path__ + "img/whitePencil.8b327126.svg";